export const DEFAULT_BIBLE_TRANSLATION = 'WEBP';

export const bibleTranslations = [
  {
    id: 'WEBP',
    abbreviation: 'WEB',
    name: 'World English Bible',
    language: 'English',
    languageTag: 'en-US',
    publicPath: '/bibles/webp',
    license: 'Public Domain',
    sourceName: 'eBible.org',
    sourceUrl: 'https://ebible.org/find/show.php?id=engwebp'
  }
];

export const getBibleTranslation = (translationId) =>
  bibleTranslations.find((translation) => translation.id === translationId) || null;

export default bibleTranslations;
